<div class="icon-container">
    <mat-icon class="cart-icon" routerLink="/cart">shopping_cart</mat-icon>
    <span class="cart-counter" *ngIf="cartItems > 0">{{ cartItems }}</span>
</div>
